<template>
    <div
        class="hts-switch"
        :class="{ active: modelValue }"
        @click="handleClick()">
        <div class="cursor-pointer">
            <div class="flex items-center">
                <component
                    :is="icon"
                    v-if="icon"
                    class="icon w-5 h-5 mr-1" />
                <span>
                    {{ label }}
                </span>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    default: ''
  },
  icon: {
    type: String
  }
})
const { label, modelValue } = toRefs(props)

const emits = defineEmits(['update:modelValue', 'change'])

const active = ref(false)

const handleClick = () => {
  const newValue = !modelValue.value
  emits('update:modelValue', newValue)
  nextTick(() => {
    emits('change', newValue)
  })
}
</script>
